import { Link } from "react-router-dom";
import "./footer.css";

import { COMPANY } from "../data/company";
import { byPath } from "../data/registry";

const SUPPORT_EMAIL = COMPANY.supportEmail;

const GROUPS = [
  {
    heading: "Apps",
    links: [
      {
        label: "Varzish Mate on Google Play",
        href: COMPANY.urls.playClub,
      },
      {
        label: "Varzish Mate on the App Store",
        href: COMPANY.urls.appStoreClub,
      },
      {
        label: "Web app, for any browser",
        href: `${COMPANY.urls.console}/login`,
      },
    ],
  },
  {
    heading: "Resources",
    // Only hubs that exist in the registry, so there are no dead links.
    links: [
      { label: "Guides", to: "/guides" },
      { label: "Compare", to: "/compare" },
      { label: "Free tools", to: "/tools" },
    ].filter((l) => byPath(l.to)),
  },
  {
    heading: "Compare",
    // One link per comparison page, on every page of the site, so a crawler
    // that has only seen the home page can reach all of them in one hop.
    links: [
      { label: "Easy Gym Software alternative", to: "/compare/easy-gym-software-alternative" },
      { label: "Wellyx alternative", to: "/compare/wellyx-alternative" },
      { label: "FitnessForce alternative", to: "/compare/fitnessforce-alternative" },
      { label: "Excel vs gym app", to: "/compare/excel-vs-gym-app" },
      { label: "Register vs gym app", to: "/compare/gym-register-vs-app" },
      { label: "WhatsApp groups vs gym app", to: "/compare/whatsapp-groups-vs-gym-app" },
    ].filter((l) => byPath(l.to)),
  },
  {
    heading: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Pricing", to: "/pricing" },
      { label: "Help", to: "/help" },
      { label: "Contact", to: "/contact" },
      { label: "YouTube", href: COMPANY.urls.youtube },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "Refunds & Cancellation", to: "/refunds" },
      { label: "Delete your account", to: "/delete-account" },
    ],
  },
];

/*
 * There is no social row. The old footer linked to facebook.com/yourusername,
 * instagram.com/yourusername, and twitter.com/yourusername — three placeholders
 * that were never filled in. Shipping them is three broken links; add the row
 * back the day there are real handles to point at.
 */
export default function Footer() {
  return (
    <footer className="footer hairline-top" role="contentinfo">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Link className="footer__wordmark" to="/">
            Varzish Mate
          </Link>
          <p className="footer__tagline">
            Run your gym from your phone or any browser. Members, money,
            QR check-in and reminders.
          </p>
        </div>

        <nav className="footer__groups" aria-label="Footer">
          {GROUPS.filter((group) => group.links.length > 0).map((group) => (
            <div className="footer__group" key={group.heading}>
              <h2 className="footer__heading">{group.heading}</h2>
              <ul className="footer__list">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link className="footer__link" to={link.to}>
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        className="footer__link"
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="footer__group">
            <h2 className="footer__heading">Contact</h2>
            <ul className="footer__list">
              <li>
                <a className="footer__link" href={`mailto:${SUPPORT_EMAIL}`}>
                  {SUPPORT_EMAIL}
                </a>
              </li>
              <li>
                <span className="footer__note">We answer within one working day</span>
              </li>
            </ul>
          </div>
        </nav>

        <div className="footer__bottom hairline-top">
          <p>
            © {new Date().getFullYear()} Varzish Mate. All rights reserved.
          </p>
          {/*
            On every page, not just /about and /contact. Razorpay, Meta and Play
            each check the registered entity rather than the brand, and whichever
            page a reviewer lands on first is the one that has to connect them.
          */}
          <p>{COMPANY.entity}</p>
          {/* The store badges' licences ask for these two lines wherever a badge is shown. */}
          <p>
            App Store is a service mark of Apple Inc. Google Play and the Google Play logo are trademarks of Google LLC.
          </p>
        </div>
      </div>
    </footer>
  );
}
